/* Graph of Life brand v1.1.0 · tokens.json */
import React from 'react';

export const SectionHeading = ({ eyebrow, heading, children, id, as = 'h2' }) => {
  const Heading = as;
  return (
    <div className="section-heading space-y-5 max-w-3xl" id={id} data-testid={`heading-${id || String(eyebrow || heading).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '')}`}>
      {eyebrow && (
        <div className="flex items-center gap-3">
          <span
            className="w-1.5 h-1.5 rounded-full bg-teal-400 shadow-[0_0_12px_rgba(45,212,191,0.8)]"
            aria-hidden="true"
          />
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-teal-400">{eyebrow}</p>
        </div>
      )}
      {heading && (
        <Heading className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.12] text-sand-50">
          {heading}
        </Heading>
      )}
      {children && <div className="text-base md:text-lg font-light leading-relaxed text-sand-50/65">{children}</div>}
    </div>
  );
};

export default SectionHeading;
